import React, { useState } from "react";
import { motion } from "framer-motion";
import NewsImages from "./NewsImages";
import dateFormat from "../../../../utils/dateFormat";

export default function NewsItem({ news }) {
  const [collapse, setCollapse] = useState(false);

  return (
    <div
      className="d-flex gap-4 flex-column flex-md-row bg-light p-lg-4 p-3 rounded"
      style={{
        width: "100%", // Set width to 100% for desktop view
      }}
    >
      <div style={{ width: "100%", maxWidth: "15rem" }}>
        {/* <NewsImages images={news.images} /> */}
        <img
          src={news?.images[0] || ""}
          style={{
            objectFit: "cover",
            width: "100%",
          }}
          alt="..."
        />
      </div>
      <div style={{ width: "100%" }}>
        <p
          className="m-0 text-primary pb-1"
          style={{ fontSize: ".8rem", fontStyle: "italic" }}
        >
          {dateFormat(news?.createdAt)}
        </p>
        <h5 className="fw-bold text-primary">{news?.title}</h5>

        {collapse || window.innerWidth >= 768 ? (
          <motion.p
            animate={{ opacity: 1, y: 0 }}
            initial={{ opacity: 0, y: -30 }}
            className="pt-2"
          >
            {news?.description}
          </motion.p>
        ) : null}

        {window.innerWidth < 768 && (
          <div className="d-flex justify-content-end">
            <button
              className="btn btn-link fw-semibold p-0 m-0 opacity-75"
              style={{ fontSize: ".9rem", width: "fit-content" }}
              onClick={() => setCollapse(!collapse)}
            >
              {collapse ? "See Less" : "See more"}
              {collapse ? (
                <i className="bi bi-chevron-up ps-1"></i>
              ) : (
                <i className="bi bi-chevron-down ps-1"></i>
              )}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
